import { Action } from '@ngrx/store';

import { Tenant } from './tenant';

export enum TenantActionTypes {
  INITIALISE = '[Tenant] Initialise',
  LOAD = '[Tenant] Load',
}

export class InitialiseWithTenantAction implements Action {
  readonly type = TenantActionTypes.INITIALISE;

  constructor(public payload: Tenant) {}
}

export class LoadTenantAction implements Action {
  readonly type = TenantActionTypes.LOAD;

  constructor(public payload: { tenantCode: string }) {}
}

export type TenantActions = InitialiseWithTenantAction | LoadTenantAction;
